import SubCategoryScroller, { SubCategoryScrollerProps } from './SubCategoryScroller';

export default SubCategoryScroller;
export type { SubCategoryScrollerProps };
